import React, {Component, Fragment} from 'react';
import {graphql} from 'react-apollo';
import {autobind} from 'core-decorators';
import {Grid} from '@material-ui/core';
import {Form, Field, Input, Textarea} from 'components/forms';
import createContactMutation from 'graphql/mutations/create-contact.gql';
import Button from 'components/button';
import styles from './styles.css';

@graphql(createContactMutation, {
    props: ({mutate}) => ({
        onSubmit: variables => mutate({variables}),
    }),
})
@autobind
export default class ContactForm extends Component {
    state = {
        success: false,
    };

    async handleSubmit(values) {
        this.setState({loading: true, errors: undefined});
        const response = await this.props.onSubmit(values);
        const {errors} = response.data.createContact;
        if (errors) return this.setState({loading: false, errors});
        return this.setState({success: true});
    }

    renderSuccess() {
        return (
            <div className={styles.success}>
                <div className={styles.title}>¡Formulario enviado exitosamente!</div>
                <div className={styles.subtitle}>En breve nos contactaremos con vos.</div>
            </div>
        );
    }

    renderForm() {
        return (
            <Form
                fields={[
                    {key: 'firstName'},
                    {key: 'lastName'},
                    {key: 'email', validators: ['email']},
                    {key: 'subject'},
                    {key: 'message'},
                ]}
                errors={this.state.errors}
                onSubmit={this.handleSubmit}>
                {({getFieldProps, renderErrors, isValid}) => (
                    <Fragment>
                        <Grid container spacing={2} justify='flex-end'>
                            <Grid item xs={12} md={4}>
                                <Field label='Nombre'>
                                    <Input
                                        type='text'
                                        {...getFieldProps('firstName')}
                                    />
                                    {renderErrors('firstName')}
                                </Field>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Field label='Apellido'>
                                    <Input
                                        type='text'
                                        {...getFieldProps('lastName')}
                                    />
                                    {renderErrors('lastName')}
                                </Field>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Field label='Email'>
                                    <Input
                                        type='email'
                                        {...getFieldProps('email')}
                                    />
                                    {renderErrors('email')}
                                </Field>
                            </Grid>
                            <Grid item xs={12}>
                                <Field label='Asunto'>
                                    <Input
                                        type='text'
                                        {...getFieldProps('subject')}
                                    />
                                    {renderErrors('subject')}
                                </Field>
                            </Grid>
                            <Grid item xs={12}>
                                <Field label='Mensaje'>
                                    <Textarea
                                        {...getFieldProps('message')}
                                    />
                                    {renderErrors('message')}
                                </Field>
                                {renderErrors('__all__')}
                            </Grid>
                            <Grid className={styles.action} item xs={4} alignItems='flex-end'>
                                <Button className={styles.button} theme='yellow' disabled={!isValid() || this.state.loading}>
                                    ENVIAR
                                </Button>
                            </Grid>
                        </Grid>
                    </Fragment>
                )}
            </Form>
        );
    }

    render() {
        return (
            <div className={styles.root}>
                {this.state.success ? this.renderSuccess() : this.renderForm()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/contact-form/index.js